module.exports = __webpack_public_path__ + "img/06-defaul.fa221c89.png";